import React from "react";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div/Div";
import { Grid, Typography } from "@mui/material";

const PartnerDashboard = () => {
  const { t } = useTranslation();

  return (
    <Div>
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12}>
          <Typography variant="h2">
            {t("pages.home.dashboards.partnerTitle", {
              defaultValue: "Welcome to the Datavision",
            })}
          </Typography>
        </Grid>
      </Grid>
    </Div>
  );
};

export default PartnerDashboard;
